import React from 'react';
import './LanguageSelector.css';

const LanguageSelector = (props) => {
  const englishActive = props.languageSetting === "ENGLISH";
  const spanishActive = props.languageSetting === "SPANISH";

  return (
    <div className="language-selector-container">
      <div className="language-selector">
        <h2>Select Language</h2>
        <div className="language-options">
          <div
            className={`language-option ${englishActive ? 'selected' : ''}`}
            onClick={() => props.onLanguageChange('ENGLISH')}
          >
            English
          </div>
          <div
            className={`language-option ${spanishActive ? 'selected' : ''}`}
            onClick={() => props.onLanguageChange('SPANISH')}
          >
            Español
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;
